/**
 * UI-only route guard — hides routes when a feature is not allowed for display.
 * Not a security boundary; backend APIs enforce authorization.
 */
import { Navigate } from "react-router-dom";
import { useFeatureAccess } from "../utils/featureAccess";
import PropTypes from "prop-types";

const ProtectedRoute = ({ children, featureId, fallbackPath = "/" }) => {
  const { isAllowed } = useFeatureAccess();
  return isAllowed(featureId) ? children : <Navigate to={fallbackPath} replace />;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  featureId: PropTypes.string.isRequired,
  fallbackPath: PropTypes.string,
};

export default ProtectedRoute;
